import React from 'react';
import CategoryAccordion from 'components/CategoryAccordion/CategoryAccordion';
import {categoryLookup} from 'utils/utils';

const Navigation = ({
    categories,
    partition,
    id,
    homeId,
    isMobile,
    location,
    translations,
    collapse,
}) => {
    const topLevelCategories = categoryLookup(categories, 'parentId', homeId);
    const navigationItems =
        topLevelCategories && Array.isArray(topLevelCategories)
            ? topLevelCategories
            : [topLevelCategories];

    return navigationItems
        .filter((cat) => {
            if (partition) {
                return id === cat.sys.id;
            }
            return !cat.partition;
        })
        .map((category, index) => (
            <CategoryAccordion
                key={index}
                isActive={location.pathname.indexOf(`${category.path}`) > -1}
                level={1}
                isMobile={isMobile}
                location={location}
                allCategories={categories}
                translations={translations}
                collapse={collapse}
                {...category}
            />
        ));
};

export default Navigation;
